import React, { Fragment } from "react";
import styled, { withTheme } from "styled-components";
import Icon from "./Icon";

const IconWrapper = styled.div`
  width: 40px;
  height: 40px;
  min-height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 20px;
`;
const ItemName = styled.p`
  color: ${(props) =>
    props.color || "rgba(255, 255, 255, 0.9)"}; /*hover color */
  font-weight: normal;
  font-size: 14px;
  position: relative;
  padding-left: ${(props) => props.paddingLeft || "18px"};
  user-select: none;
  ${(props) =>
    props.hoverable &&
    `
  :hover {
    font-weight: normal;
  }
  `};
`;

const ItemWrapper = styled.div`
  width: ${(props) => (props.hideItemName ? 75 : "auto")}px;
  height: 48px;
  display: flex;
  align-items: center;
  cursor: pointer;
  box-sizing: border-box;
  position: relative;
  background: transparent;
  color: #fff;
  transition: 0.2s ease-in;
  ${(props) =>
    props.hideItemName &&
    `
    padding-left: 0;
    justify-content: center;
  `};
  &:hover {
    filter: invert(0.3);
  }
  ${(props) =>
    props.active &&
    `
     >p {
      color: #fff;
      font-weight: 600;
    }
  `};
  ${(props) =>
    props.theme &&
    `
    &:after {
      background-color:${props.theme.secondary} ;
      box-shadow: 2px 1px 11px 0px ${props.theme.secondary} !important;
  `};
`;

const MenuItem = ({
  active,
  iconName = "",
  hideItemName,
  isVendor,
  theme,
  children,
  ...props
}) => {
  return (
    <Fragment>
      <ItemWrapper isVendor={isVendor} hideItemName={hideItemName} {...props}>
        {iconName ? (
          <IconWrapper>
            <Icon
              icon={iconName ? iconName : "dashboard"}
              color={"rgba(100,255,255,1)"}
            />
          </IconWrapper>
        ) : null}
        {!hideItemName && <ItemName theme={theme}>{children}</ItemName>}
      </ItemWrapper>
    </Fragment>
  );
};

export default withTheme(MenuItem);
